import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/router";
import { useEffect, useMemo, useState } from "react";
import { inspectorAuthInteractor } from "@/client/amplify/auth";
import { useRemoteAssessmentVisible } from "@/hooks/storage/useRemoteAssessmentVisible";
import { useViewModeFlg } from "@/hooks/storage/useViewModeFlg";
export const useContainer = () => {
  const $ = _c(8);
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const {
    viewModeEnabled
  } = useViewModeFlg();
  const {
    visible: remoteAssessmentVisible
  } = useRemoteAssessmentVisible();
  const currentPath = router.pathname;
  const [isSamlUser, setIsSamlUser] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let isMounted = true;
      const loadAuthInfo = async () => {
        try {
          const {
            isMasterUser
          } = await inspectorAuthInteractor.getAuthInfo({});
          if (isMounted) {
            setIsSamlUser(isMasterUser);
          }
        } catch {
          if (isMounted) {
            setIsSamlUser(false);
          }
        }
      };
      loadAuthInfo();
      return () => {
        isMounted = false;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] !== currentPath || $[3] !== isSamlUser || $[4] !== open || $[5] !== remoteAssessmentVisible || $[6] !== viewModeEnabled) {
    t2 = {
      open,
      setOpen,
      currentPath,
      viewModeEnabled,
      isSamlUser,
      remoteAssessmentVisible
    };
    $[2] = currentPath;
    $[3] = isSamlUser;
    $[4] = open;
    $[5] = remoteAssessmentVisible;
    $[6] = viewModeEnabled;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};